import React, { useState } from 'react';
/**
 * 
 *  message - text to display
 *  type - info, danger, success
 * @returns 
 */
const Notification = ({message, type, closable=false, visibility=true}) => {
    const [show, setShow] = useState(visibility);
    
    return (<>

        {show && <div className={`alert alert-${type || 'light'} alert-dismissible fade show`} role="alert">
        {closable && <button type="button" className="close" aria-label="Close" onClick={()=>setShow(false)}>
        <span aria-hidden="true">×</span>
        </button>}
        {message}
        </div>}
        </>
    );
};

export default Notification;